import { validationSummary } from "../../lib/validations";
import { AxiosError, AxiosResponse } from "axios";
import { getTranslations } from "../../lib/translations";

export class messagesModel {
    unauthorizedUserTitle: string = "";
    unauthorizedUser: string = "";
    badRequestTitle: string = "";
    badRequest: string = "";
    notFoundTitle: string = "";
    notFound: string = "";
    anErrorOccurred: string = "";
    badGatewayError: string = "";
    gatewayTimeoutError: string = "";
    serviceUnavailableError: string = "";
}

var msgModel = new messagesModel();

const initialize = () => {
    getErrorTranslations();
}
/**
 * Check what the status code is from the responseURL
 * @param response The axios response
 * @returns `true` if the response is an error. `false` if the response is successful
 */
export const isErrorResponse = (
    response: AxiosResponse
) => {
    var statusCode = response.request?.responseURL ? GetStatusCode(response.request.responseURL) : response.status;
    var isErrorStatusCode = false
    console.log(statusCode)
    switch (statusCode) {
        case 200: {
            isErrorStatusCode = false;
            break;
        }
        case 400: {
            validationSummary({
                level: "error",
                title: msgModel.badRequestTitle,
                body: msgModel.badRequest
            });
            isErrorStatusCode = true;
            break;
        }
        case 401: {
            validationSummary({
                level: "error",
                title: msgModel.unauthorizedUserTitle,
                body: msgModel.unauthorizedUser
            });
            isErrorStatusCode = true;
            break;
        }
        case 404: {
            validationSummary({
                level: "error",
                title: msgModel.notFoundTitle,
                body: msgModel.notFound
            });
            isErrorStatusCode = true;
            break;
        }
        case 502: {
            validationSummary({
                level: "error",
                title: msgModel.badGatewayError,
                body: msgModel.anErrorOccurred
            });
            isErrorStatusCode = true;
            break;
        }
        case 503: {
            validationSummary({
                level: "error",
                title: msgModel.serviceUnavailableError,
                body: msgModel.anErrorOccurred
            });
            isErrorStatusCode = true;
            break;
        }
        case 504: {
            validationSummary({
                level: "error",
                title: msgModel.gatewayTimeoutError,
                body: msgModel.anErrorOccurred
            });
            isErrorStatusCode = true;
            break;
        }
        default: {
            //statements;
            isErrorStatusCode = false;
            break;
        }
    }
    return isErrorStatusCode;
};

/**
 * Check if a given object is an AxiosError object
 *
 * @param error
 * @returns `true` if the object is an AxiosError, otherwise `false`
 */
export function isAxiosError(error: any): error is AxiosError {
    return error?.isAxiosError ?? false;
}

function GetStatusCode(responseURL: string) {
    if (responseURL.includes('Error')) {
        var statusCode: number = +String(responseURL.split('?code=').pop());
        return statusCode;
    } else {
        return 200;
    }
}

/**
 * Get an error message from a given error to show to the user. If an error message can't be found, a generic error message will be used.
 * @param error The error that was thrown
 * @returns An error to display to the user
 */
export async function getErrorMessage(error: unknown | AxiosError<any>): Promise<string> {
    /** The error message to fall back to if one cannot be derived from the error object */
    const fallbackErrorMessage = msgModel.anErrorOccurred || "An error occurred";

    if (isAxiosError(error)) {
        const downloadResponseTypes = ["blob", "arraybuffer"];
        if (downloadResponseTypes.includes(error.request.responseType)) {
            // Certain response types need to have their data converted to text
            const data = error.response?.data as any;
            return await data?.text() || fallbackErrorMessage
        }

        if (error.response?.data) {
            const data = error.response.data;
            return typeof data === 'string' ? data : JSON.stringify(data);
        }
    }

    if (error) {
        return `${error}`;
    }

    return fallbackErrorMessage;
}

const getErrorTranslations = async () => {
    const translations = (await getTranslations());
    msgModel.unauthorizedUserTitle = translations.UnauthorizedTitle;
    msgModel.unauthorizedUser = translations.Unauthorized;
    msgModel.badRequestTitle = translations.BadRequestTitle;
    msgModel.badRequest = translations.BadRequest;
    msgModel.notFoundTitle = translations.NotFoundTitle;
    msgModel.notFound = translations.NotFound;
    msgModel.anErrorOccurred = translations.ErrorTitle;
    msgModel.badGatewayError = translations.BadGatewayError;
    msgModel.gatewayTimeoutError = translations.GatewayTimeoutError;
    msgModel.serviceUnavailableError = translations.ServiceUnavailableError;
}
initialize();
